import Modal from "@/common/components/Modal";
import { useState } from "react";
import { MaintenanceSpecificationValidationSchema } from "../../../schemas/update.schema";
import { EstablishmentLeadData } from "../../../types/establishmentLead.type";
import { useQueryClient } from "@tanstack/react-query";
import { FormTransformers } from "@/common/utils/formTransformers";
import { Trash2Icon } from "lucide-react";
import { useDeleteEstablishmentLeadMaintenanceSpecification } from "@/features/establishmentLeadsFunnel/hooks/maintenanceModules/useDeleteEstablishmentLeadMaintenanceSpecification";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import Button from "@/common/components/Button";

interface DeleteMaintenanceSpecificationModalProps {
  establishmentLead: EstablishmentLeadData;
  maintenanceSpecification: EstablishmentLeadData['maintenance_specifications'][number];
  disabled?: boolean;
}

const DeleteMaintenanceSpecificationModal = ({
  establishmentLead,
  maintenanceSpecification,
  disabled,
}: DeleteMaintenanceSpecificationModalProps) => {
  const queryClient = useQueryClient();

  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteEstablishmentLeadMaintenanceSpecification,
    isPending: deleteEstablishmentLeadMaintenanceSpecificationIsPending,
  } = useDeleteEstablishmentLeadMaintenanceSpecification({
    establishmentLeadId: establishmentLead.id,
    maintenanceSpecification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentLead', establishmentLead.id] });

      setOpen(false);
    },
    onError: FormTransformers.errorsTransformer<MaintenanceSpecificationValidationSchema>({
      setMessages,
    }),
  });

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Modal
        isOpen={open}
        setIsOpen={setOpen}
        triggerDisabled={disabled}
        Trigger={(
          <Button
            variant="link-white"
            className="w-full"
            operationKlassToCheckPermission="Admin::Funnel::Establishment::Leads::UpdateMaintenanceModels"
            disabled={disabled}
          >
            <Trash2Icon
              className="text-danger-soft"
              strokeWidth={1}
            />
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={deleteEstablishmentLeadMaintenanceSpecification}
        confirmButtonIsLoading={deleteEstablishmentLeadMaintenanceSpecificationIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </div>
  );
}

export default DeleteMaintenanceSpecificationModal;
